import { render } from "./DrugInfo.vue?vue&type=template&id=d41c5628&scoped=true"
import script from "./DrugInfo.vue?vue&type=script&lang=js"
export * from "./DrugInfo.vue?vue&type=script&lang=js"

import "./DrugInfo.vue?vue&type=style&index=0&id=d41c5628&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d41c5628"],['__file',"src/views/pharmarcy/DrugInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d41c5628"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d41c5628', __exports__)) {
    api.reload('d41c5628', __exports__)
  }
  
  module.hot.accept("./DrugInfo.vue?vue&type=template&id=d41c5628&scoped=true", () => {
    api.rerender('d41c5628', render)
  })

}


export default __exports__